import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useService } from '../../services/services';
import { route } from '../../services/utils';
import Form from '../../components/form';
import Checkbox from '../../components/form/elements/checkbox';
import Readonly from '../../components/form/elements/readonly';
import Group from '../../components/form/elements/group';
import Text from '../../components/form/elements/text';
import Link from '../../components/form/elements/link';
import { FARM_EDIT } from '../../router/routes';
import { useObservableState } from 'observable-hooks';
import Farm, { Sector } from '../../interfaces/farm';
import { useParams } from 'react-router-dom';
import { map } from 'rxjs/operators';
import TextArea from '../../components/form/elements/text-area';

export default function FarmView() {
  const { t } = useTranslation();
  const { farmService } = useService();

  const { farmId } = useParams<{ farmId: string }>();
  const [farm] = useObservableState<Farm>(
    () =>
      farmService.show(farmId).pipe(
        map((farm) => {
          farm.sectors = Object.fromEntries(
            (farm.sectors as Sector[]).map((value) => [value, true])
          ) as { [key in Sector]: boolean };

          return farm;
        })
      ),
    null
  );

  const [bodyElements, setBodyElements] = useState([]);
  const [footerElements, setFooterElements] = useState([]);

  useEffect(() => {
    if (farm !== null) {
      setBodyElements([
        Readonly([
          Group([
            Text('name', t('pages.farm.name')),
            Text('registration_number', t('pages.farm.registration-number')),
            Text('legal_address', t('legal_address')),
            Checkbox('vat', t('pages.farm.vat')),
            Checkbox('sectors.warehouse', t('pages.farm.warehouse')),
            Checkbox('sectors.crop', t('pages.farm.crop')),
            Checkbox('sectors.livestock', t('pages.farm.livestock')),
            Text('bank_name', t('pages.farm.bank-name')),
            Text('account_number', t('pages.farm.account-number')),
            TextArea('comment', t('pages.farm.comment')),
          ]),
        ]),
      ]);

      setFooterElements([
        Link(route(FARM_EDIT, { farmId: farm.id }), 'edit', true),
      ]);
    }
  }, [farm, t, setBodyElements, setFooterElements]);

  return (
    <Form
      mode={'view'}
      title={t('pages.farm.title')}
      backTo={null}
      body={bodyElements}
      footer={footerElements}
      values={farm}
      submit={null}
      schema={null}
      noticeAccessor="ViewForm"
    />
  );
}
